export default __webpack_public_path__ + "static/media/carousel_4.2a5f35ca.jpg";